import { render, staticRenderFns } from "./Ptspdetail.vue?vue&type=template&id=bc4ec5c0"
import script from "./Ptspdetail.vue?vue&type=script&lang=js"
export * from "./Ptspdetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports